import React from 'react';

const Breadcumb = ({ pageTitle, backgroundImage }) => {
  return (
    <div>
      <div 
        className="site-breadcrumb" 
        style={{ background: `url(${backgroundImage})` }}
      >
        <div className="container">
          <h2 className="breadcrumb-title">{pageTitle}</h2>
          <ul className="breadcrumb-menu">
            <li><a href="/">Home</a></li>
            <li className="active">{pageTitle}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Breadcumb;